import React, { useState } from "react";
import { useClientAuth } from "../../context/ClientAuthContext";
import { useNavigate } from "react-router-dom";
import Header from "../../components/appLayout/header";
import Popup from "../../components/common/Popup";
import "./index.scss";

const ProfilePage = () => {
  const { currentClient, handleClientLogout, updateCurrentClient } = useClientAuth();
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({
    name: currentClient?.name || '',
    email: currentClient?.email || '',
    telephone: currentClient?.telephone || ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const handleLogout = async () => {
    await handleClientLogout();
    navigate("/");
  };

  const handleEdit = () => {
    setIsEditing(true);
    setEditData({
      name: currentClient?.name || '',
      email: currentClient?.email || '',
      telephone: currentClient?.telephone || ''
    });
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      // Here you would call an API to update the user
      // For now, just update the local state
      updateCurrentClient(editData);
      setIsEditing(false);
      setPopupMessage("Profil mis à jour avec succès !");
      setShowSuccessPopup(true);
    } catch (error) {
      setPopupMessage("Erreur lors de la mise à jour du profil");
      setShowSuccessPopup(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditData({
      name: currentClient?.name || '',
      email: currentClient?.email || '',
      telephone: currentClient?.telephone || ''
    });
  };

  const handleDeleteAccount = () => {
    setShowDeletePopup(true);
  };

  const confirmDeleteAccount = () => {
    setShowDeletePopup(false);
    // Here you would call an API to delete the account
    setPopupMessage("Fonctionnalité de suppression en cours de développement");
    setShowSuccessPopup(true);
  };

  const handlePopupClose = () => {
    setShowSuccessPopup(false);
    setShowDeletePopup(false);
  };

  if (!currentClient) {
    return (
      <div className="profile-page">
        <div className="profile-container">
          <div className="profile-error">
            <h2>Non connecté</h2>
            <p>Veuillez vous connecter pour accéder à votre profil.</p>
            <button 
              className="btn-primary"
              onClick={() => navigate("/login-page")}>
              Se connecter
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-page">
      <Header />
      <div className="profile-container">
        {/* Header with title and line */}
        <div className="profile-header">
          <h1>MON PROFIL</h1>
          <div className="header-line"></div>
        </div>

        {/* Profile Information Section */}
        <div className="profile-info-section">
          <div className="profile-avatar">
            <div className="avatar-square">
              {currentClient.name ? currentClient.name.charAt(0).toUpperCase() : 'U'}
            </div>
          </div>
          
          <div className="profile-details">
            {isEditing ? (
              <div className="edit-form">
                <div className="form-group">
                  <label>Nom:</label>
                  <input
                    type="text"
                    value={editData.name}
                    onChange={(e) => setEditData({...editData, name: e.target.value})}
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label>Email:</label>
                  <input
                    type="email"
                    value={editData.email}
                    onChange={(e) => setEditData({...editData, email: e.target.value})}
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label>Téléphone:</label>
                  <input
                    type="tel"
                    value={editData.telephone}
                    onChange={(e) => setEditData({...editData, telephone: e.target.value})}
                    className="form-input"
                  />
                </div>
                <div className="form-actions">
                  <button 
                    className="btn-save"
                    onClick={handleSave}
                    disabled={isLoading}>
                    {isLoading ? "Sauvegarde..." : "Sauvegarder"}
                  </button>
                  <button 
                    className="btn-cancel"
                    onClick={handleCancel}>
                    Annuler
                  </button>
                </div>
              </div>
            ) : (
              <>
                <h2 className="profile-name">{currentClient.name || 'Utilisateur'}</h2>
                <p className="profile-email">{currentClient.email}</p>
                <p className="profile-role">client</p>
                <button 
                  className="btn-edit"
                  onClick={handleEdit}>
                  <span className="edit-icon">✏️</span>
                  MODIFIER MON PROFIL
                </button>
              </>
            )}
          </div>
        </div>

        {/* Main Action Cards */}
        <div className="main-actions">
          <div className="action-card orders-card">
            <h3>MES COMMANDES</h3>
            <p>CONSULTEZ L'HISTORIQUE DE VOS COMMANDES</p>
            <button 
              className="btn-action"
              onClick={() => navigate("/orders")}>
              VOIR MES COMMMANDES
            </button>
          </div>

          <div className="action-card personal-card">
            <h3>INFORMATIONS PERSONNELLES</h3>
            <p>MODIFIEZ VOS INFORMATIONS DE CONTACT</p>
            <button className="btn-action">VOIR MES COMMMANDES</button>
          </div>

          <div className="action-card preferences-card">
            <h3>PRÉFÉRENCES</h3>
            <p>GÉREZ VOS PRÉFÉRENCES DECOMPTE</p>
            <button className="btn-action">PARAMÉTRES</button>
          </div>

          <div className="action-card danger-card">
            <h3>ZONE DE DANGER</h3>
            <p>SUPPRIMER MON COMPTE</p>
            <button 
              className="btn-danger"
              onClick={handleDeleteAccount}>
              SUPPRIMER MON COMPTE
            </button>
          </div>
        </div>

        {/* Logout Button */}
        <div className="logout-section">
          <button 
            className="btn-logout"
            onClick={handleLogout}>
            <span className="logout-icon">←</span>
            DECONNEXION
          </button>
        </div>
      </div>

      {/* Success/Info Popup */}
      <Popup
        isOpen={showSuccessPopup}
        onClose={handlePopupClose}
        title={popupMessage.includes("succès") ? "Succès!" : "Information"}
        message={popupMessage}
        type={popupMessage.includes("succès") ? "success" : "info"}
        buttonText="Fermer"
        onButtonClick={handlePopupClose}
      />

      {/* Delete Confirmation Popup */}
      <Popup
        isOpen={showDeletePopup}
        onClose={handlePopupClose}
        title="Supprimer le compte"
        message="Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible et supprimera définitivement toutes vos données."
        type="warning"
        buttonText="Confirmer la suppression"
        onButtonClick={confirmDeleteAccount}
        showCancel={true}
        cancelButtonText="Annuler"
        onCancelClick={handlePopupClose}
      />
    </div>
  );
};

export default ProfilePage;
